var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheLoader',{attrs:{"showLoader":_vm.isLoading}}),_c('PageOverview',{attrs:{"sectionTitle":"Your Panda accounts"}}),_c('ConditionalCtas'),_c('FooterCtas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }